
export default function ServiceIntro() {
  const services = [
    {
      icon: '刀',
      title: '日本刀',
      description: '太刀、刀、脇差、短刀など、あらゆる日本刀を高価買取いたします。銘の有無に関わらず、専門鑑定士が海外バイヤーと連携し高額査定いたします。１００万円オーバーも珍しくありません。',
      image: 'https://public.readdy.ai/ai/img_res/759377602786d94ad349d2b46ace08f8.jpg',
    },
    {
      icon: '鎧',
      title: '甲冑',
      description: '時代や状態を問わず買取いたします。破損品でもご相談ください。引き取りの際に必要な梱包作業はすべてお任せ下さい。状態のいい江戸期のものは１００万円を超えます。',
      image: 'https://static.readdy.ai/image/cfeb096f2856b6040564ba9975813ece/798215115e480ea830f6f9c48abd70e4.jpeg',
    },
    {
      icon: '兜',
      title: '兜',
      description: '前立て付きの兜、変わり兜、面頬など、武具全般を買取対象としております。付属品が揃っていなくても査定可能です。変わり兜、星兜、筋兜などは数十万円の高額査定になることがあります。',
      image: 'https://static.readdy.ai/image/cfeb096f2856b6040564ba9975813ece/67246a463a51483ca0c551020cda5c1a.jpeg',
    },
  ];

  return (
    <section id="service" className="py-20 lg:py-28 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <header className="text-center mb-16">
          <div className="inline-block bg-samurai-red/10 px-6 py-2 rounded-full mb-6">
            <p className="text-samurai-red font-bold text-base lg:text-lg whitespace-nowrap">SERVICE</p>
          </div>
          <h2 className="text-4xl lg:text-5xl font-black text-samurai-dark mb-6 font-serif">
            買取対象品目
          </h2>
          <p className="text-xl lg:text-2xl text-samurai-gray max-w-3xl mx-auto leading-relaxed">
            <strong>日本刀買取</strong>・<strong>甲冑買取</strong>・<strong>兜買取</strong>を中心に、武具全般の買取を行っております
          </p>
        </header>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-10">
          {services.map((service, index) => (
            <article
              key={index}
              className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
            >
              <div className="relative h-64 overflow-hidden">
                <img
                  src={service.image}
                  alt={`${service.title}買取 - 神奈川県横須賀市 勝手屋の${service.title}高価買取サービス`}
                  title={`${service.title}買取専門 勝手屋`}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute top-4 left-4 bg-samurai-red text-white w-16 h-16 rounded-full flex items-center justify-center shadow-lg">
                  <span className="text-3xl font-black font-serif">{service.icon}</span>
                </div>
              </div>
              <div className="p-8">
                <h3 className="text-2xl lg:text-3xl font-black text-samurai-dark mb-4 font-serif whitespace-nowrap">
                  <strong>{service.title}買取</strong>
                </h3>
                <p className="text-lg text-samurai-gray leading-relaxed">
                  {service.description}
                </p>
              </div>
            </article>
          ))}
        </div>

        <aside className="mt-16 bg-samurai-gold/10 border-2 border-samurai-gold rounded-2xl p-8 lg:p-12">
          <div className="flex flex-col lg:flex-row items-center gap-8">
            <div className="w-20 h-20 flex items-center justify-center flex-shrink-0">
              <i className="ri-information-line text-6xl text-samurai-gold"></i>
            </div>
            <div className="flex-1 text-center lg:text-left">
              <h4 className="text-2xl lg:text-3xl font-bold text-samurai-dark mb-3 whitespace-nowrap">
                その他の武具も買取可能
              </h4>
              <p className="text-lg lg:text-xl text-samurai-gray leading-relaxed">
                <strong>鍔買取</strong>、<strong>目貫買取</strong>、<strong>小柄買取</strong>、<strong>笄買取</strong>などの<strong>刀装具買取</strong>、<strong>武具全般の買取</strong>を行っております。お気軽にご相談ください。
              </p>
            </div>
          </div>
        </aside>
      </div>
    </section>
  );
}